"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
var _style = _interopRequireDefault(require("./style.css"));
var _color = _interopRequireDefault(require("color"));
var _modalOn = _interopRequireDefault(require("./modalOn.png"));
var _modalOff = _interopRequireDefault(require("./modalOff.png"));
var _aspectRatioOptions = _interopRequireDefault(require("./aspectRatioOptions.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialValues = exports.initialValues = {
  mustTakeInOrder: true,
  showLastVisited: false,
  showLessonNum: true,
  showProgressBubbleNum: true,
  showLessonsInModal: false,
  suppressOnComplete: true,
  aspectRatio: '',
  highlighting: '',
  requiredHighlightColor: '#c5422b',
  optionalHighlightColor: '#6f6f6f',
  baseColor: '#176987',
  buttonColors: {
    start: '#176987',
    resume: '#a95a14',
    replay: '#636466'
  },
  progressBubbleColors: {
    resume: 'primaryColor',
    replay: '#43a047'
  }
};
var Settings = function Settings(_ref) {
  var questSettings = _ref.questSettings,
    values = _ref.values;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showColors = _useState2[0],
    setShowColors = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "mustTakeInOrder",
    component: _cccisdFormik.CccisdToggle,
    label: "User must take surveys in order"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "suppressOnComplete",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Suppress completion message from Data Collection Wave", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "When a user completes all required lessons in all modules, do you want the Data Colleciton Wave completion message to show?"), /*#__PURE__*/_react["default"].createElement("p", null, "Toggling this setting to ", /*#__PURE__*/_react["default"].createElement("b", null, "NO"), " allows the message to show."), /*#__PURE__*/_react["default"].createElement("p", null, "Toggling this setting to ", /*#__PURE__*/_react["default"].createElement("b", null, "YES"), " suppresses the message and kicks users right back to the dashboard upon completing the final survey."))
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showLastVisited",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Last Visited Date"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showLessonNum",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Lesson Numbers"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showProgressBubbleNum",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Progress Bubble Numbers", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Show each lesson number within the progress bubble on the course player."
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showLessonsInModal",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Lessons in Modal", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lessonInModalTooltip
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, "YES"), /*#__PURE__*/_react["default"].createElement("img", {
        src: _modalOn["default"],
        alt: "modal on"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, "NO"), /*#__PURE__*/_react["default"].createElement("img", {
        src: _modalOff["default"],
        alt: "modal off"
      })))
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), values.showLessonsInModal ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "aspectRatio",
    component: _cccisdFormik.CccisdSelect,
    label: "Force aspect ratio",
    options: _aspectRatioOptions["default"],
    style: {
      width: 'auto'
    }
  }) : null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "highlighting"
  }, function (fieldProps) {
    // avoids React warning for passing `value` prop of null
    if (!fieldProps.field.value) {
      fieldProps.field.value = '';
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdSelect, _extends({}, fieldProps, {
      label: /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-primary"
      }, "Highlighting", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
          className: _style["default"].highlightOptions
        }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Required:"), " Highlights all lessons that have the \"Required\" setting toggled ON. Modules will be highlighted if they contain one at least one required survey."), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Optional:"), " Highlights all lessons that have the \"Required\" setting toggled OFF. Modules will be highlighted if they contain exclusively non-required surveys."))),
        placement: "top"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))),
      options: [{
        value: '',
        label: '-- None --'
      }, {
        value: 'required',
        label: 'Required'
      }, {
        value: 'optional',
        label: 'Optional'
      }]
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'text-primary ' + _style["default"].toggleColors,
    onClick: function onClick() {
      return setShowColors(function (prev) {
        return !prev;
      });
    }
  }, showColors ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "Color Settings"))), showColors && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].colorBlock
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "baseColor",
    label: "Base Color"
  }, function (fieldProps) {
    var colorValue = (0, _color["default"])((0, _cccisdColorPicker.getColor)(fieldProps.field.value));
    var contrast = colorValue.contrast((0, _color["default"])('#FBFBFB'));
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Base Color"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdColorPicker, fieldProps), contrast <= 4.4 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, "Note: The selected color may be too light. You may wish to choose a darker color for greater contrast."));
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "buttonColors.start",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Start Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "buttonColors.resume",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Resume Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "buttonColors.replay",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Replay Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "progressBubbleColors.resume",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Progress Bubble - Resume"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "progressBubbleColors.replay",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Progress Bubble - Complete"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "requiredHighlightColor",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Required Highlight Color"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "optionalHighlightColor",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Optional Highlight Color"
  })));
};
var _default = exports["default"] = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);